  
import getRandomImg from '@/assets/data/getRandomImg'
import { Button, Tag } from '@blueprintjs/core'
import { getSingleRoute, getVisibleValue } from "@libs/layouts"
import { __, wordTrim } from "@libs/utilities"
import Moment from "react-moment"
import { Link } from 'react-router-dom'
import { IPost } from 'src/libs/interfaces/layouts'
import Shortcode from 'src/libs/useful/shortcode'
  
export interface IDiaryFeedProps {
  item: IPost
  cardClass?: string
  post_date?: number
  order?: number
  i?:number
}

const PEDiarySingleFeedView = (props: IDiaryFeedProps) : JSX.Element => { 
  const routeSingle = getSingleRoute(props.item.__typename!)
  const link = routeSingle ? routeSingle.route : null  
  const vv : string = props.item[ getVisibleValue( props.item.__typename! ) ]
  const linkTo = (): string => {
    const route = getSingleRoute("PEFestProject")?.route
    return route && props.item.project?.id 
      ? 
      `/${ route }/${ props.item.project?.id }` 
      : 
      ""
  }
  return <div className={`col-12 ${props.cardClass || ""} my-3 `}>
    <div className="m-0 p-0 d-flex flex-row h-100 card"> 
      <BackLabel item={props.item} link={link} />
      <OrderLabel {...props} />
      <div className="d-flex flex-column p-4 flex-grow-100 overflow-hidden" title={ vv } >
        <h5 className='text-overflow'>
          { vv }
        </h5>
        <Shortcode content={ wordTrim( props.item.post_content, 20 ) } />
        <div className="d-flex mt-auto align-items-end">
          <Link to={linkTo()}>
            <Tag 
              minimal 
              round 
              className="small py-2 px-3 hover pointer" 
            >
              {props.item.project?.title}
            </Tag>
          </Link>
          <DateLabel post_date={props.post_date} item={props.item} />
          <LinkLabel link={link} item={props.item} />
        </div>
      </div>
    </div>
  </div>
}  
export default PEDiarySingleFeedView

const DateLabel = (props:any): JSX.Element => {
  return props.post_date
    ?
    <div className="post-date">
        <Moment locale="ru" format="D.MM.YYYY ">
            {new Date(props.item.post_date!)}
        </Moment>
    </div>
    :
    <></> 
}
const LinkLabel = (props:any): JSX.Element => {
  return props.link
    ?
    <Link
        to={"/" + props.link + "/" + props.item.id }
        className="ml-auto"
    >
        <Button 
            variant="minimal"
            endIcon="chevron-right" 
        >
            {__("More")}
        </Button>
    </Link>
    :
    <></>
}
const OrderLabel = (props: IDiaryFeedProps): JSX.Element => { 
  return props.order
    ?
    <div className="single-data-type-order position-absolute ">
        {props.order}
    </div>
    : 
    <></>
}

const BackLabel = (props: any ): JSX.Element => { 
  let thumb: string = "thumbnail"
  switch(props.item.__typename)
  {
      case "User":
          thumb = "avatar"
          break
      default:
          thumb = "thumbnail"
  }
  const imgSrc : string = props.item[ thumb ]
      ?
      props.item[ thumb ]
      :
      getRandomImg({ i: props.i }) //   null
  return props.link
    ?
    <Link
        to={"/" + props.link + "/" + props.item.id }
        className="ml-auto"
    >
        <div 
            className="post-thumbnail m-0" 
            style={{ backgroundImage:`url(${imgSrc})` }}
        />
    </Link>
    :
    <div 
        className="post-thumbnail m-0" 
        style={{ backgroundImage: `url(${imgSrc})` }}
    />
}